import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Select } from 'antd';
import PropTypes from 'prop-types';

import { sortByLocalCompare } from '../../helpers/helpers';

export default function VendorSelector({
  value,
  placeholder = 'Select a Vendor',
  allowClear = true,
  showSearch = true,
  optionFilterProp = 'label',
  divisionIds = [],
  ...rest
}) {
  const vendors = useSelector((state) => state.vendors.vendors);
  
  const filteredVendors = useMemo(() => {
    if (!divisionIds.length) return [];

    const divisionIdSet = new Set(divisionIds);
    
    const filteredVendors = Object.values(vendors).filter((vendor) => 
      vendor.active && 
      vendor.divisionIds?.some(divId => divisionIdSet.has(divId))
    );

    return filteredVendors.sort(sortByLocalCompare('name'));
  }, [vendors, divisionIds]);

  return (
    <Select
      value={value}
      placeholder={placeholder}
      allowClear={allowClear}
      showSearch={showSearch}
      optionFilterProp={optionFilterProp}
      {...rest}
    >
      {filteredVendors.map((vendor) => (
        <Select.Option
          key={vendor.id}
          value={vendor.id}
          label={vendor.name}
        >
          {vendor.name}
        </Select.Option>
      ))}
    </Select>
  );
}

VendorSelector.propTypes = {
  value: PropTypes.string,
  placeholder: PropTypes.string,
  allowClear: PropTypes.bool,
  showSearch: PropTypes.bool,
  optionFilterProp: PropTypes.string,
  divisionIds: PropTypes.arrayOf(PropTypes.string),
};

VendorSelector.defaultProps = {
  value: null,
  placeholder: 'Select a Vendor',
  allowClear: true,
  showSearch: true,
  optionFilterProp: 'label',
  divisionIds: [],
};